// extracted by mini-css-extract-plugin
module.exports = {"header":"TerminalHeader_header__9NAB7"};